import React from 'react';

export default function DetailLine(props) {
    if (!props.detail) {
        return null;
    }

    return (
        <div className="detail">
            <div className="property">{props.property}</div>

            <div dangerouslySetInnerHTML={{ __html: props.detail }} />
        </div>
    );
}

DetailLine.propTypes = {
    property: React.PropTypes.string.isRequired,
    detail: React.PropTypes.any,
};

DetailLine.defaultProps = {
    detail: '',
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/leads/detailLine.jsx